import GeneralTranslations from "../../../Common/ModuleTranslations/en";

export default {
  locale: "en",
  name: "Modification Policies",
  translation: { displayName: "Translations" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "conditionRates",
        displayName: "Conditions",
      },
      {
        fieldName: "canModifyDates",
        displayName: "Modify dates",
      },
      {
        fieldName: "canModifyAccommodations",
        displayName: "Modify accommodation",
      },
      {
        fieldName: "excludedStayDates",
        displayName: "Excluded Stay Dates",
      },
      {
        fieldName: "maxAllowedChanges",
        displayName: "Modification Limit",
      },
      {
        fieldName: "dates",
        displayName: "Modification Dates",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "hotelTicker",
        displayName: "hotel Ticker",
        widget: "hidden",
      },
      {
        fieldName: "rateTypeSection",
        displayName: "Modify dates",
        widget: "section",
      },

      {
        fieldName: "canModifyDates",
        widget: "singleSwitch",
        displayName: "Enabled",
      },
      {
        fieldName: "datesMinRelease",
        displayName: "Minimum release for modifications (days):",
        widget: "input",
      },
      {
        fieldName: "excludedStayDatesSection",
        displayName: "Excluded stay dates",
        widget: "section",
        className: "noBorderNoMargin",
      },
      {
        fieldName: "excludedStayDates",
        introductionText: [],
        widget: "nestedEntity",
        nested: true,
        entityName: "modificationBookingWindow",
        nestedTitle: "Excluded stay dates",
        minHeight: 500,
        defaultValue: [],
      },
      {
        fieldName: "datesModificationRestrictionType",
        widget: "selector",
        displayName: "Only if:",
        className: "datesSelector",
        optionDisplay: {
          AMOUNT_AND_STAY_GTE: {
            label: "Stay duration is greater than equal than the stay's duration and its amount",
          },
          STAY_GTE: {
            label: "The stay duration is the same or greater",
          },
          AMOUNT_GTE: {
            label: "The stay amount is the same or greater",
          },
          NO_RESTRICTION: {
            label: "Total freedom for changing stay dates",
          },
        },
      },
      {
        fieldName: "accommodationSection",
        displayName: "Modify accommodations",
        widget: "section",
      },
      {
        fieldName: "canModifyAccommodations",
        widget: "singleSwitch",
        displayName: "Enabled",
      },
      {
        fieldName: "accommodationMinRelease",
        displayName: "Minimum release for modifications (days):",
        widget: "input",
      },
      {
        fieldName: "accommodationModificationRestrictionType",
        displayName: "Only if:",
        widget: "selector",
        optionDisplay: {
          AMOUNT_GTE: {
            label: "The stay amount is the same or greater",
          },
          NO_RESTRICTION: {
            label: "Total freedom for changing stay dates",
          },
        },
      },
      {
        fieldName: "canChangeConditions",
        widget: "singleSwitch",
        displayName: "Rate change:",
        helpText:
          "The reservation can be modified to another available condition/rate (e.g. from CG to NR).",
      },
      {
        fieldName: "conditionSection",
        displayName: "Applies to the conditions:",
        widget: "section",
      },
      {
        fieldName: "conditions",
        widget: "multicheckbox",
        visible: ({ formValues, entity }) => entity.ticker !== "DEFAULT",
      },
      {
        fieldName: "restrictionsSection",
        displayName: "Restrictions",
        widget: "section",
      },
      {
        fieldName: "maxAllowedChanges",
        displayName: "Maximum number of modifications",
        widget: "input",
      },
      {
        fieldName: "modificationAllowedFrom",
        displayName: "Modification Dates",
        placeholder: "Enter a date",
      },
      {
        fieldName: "modificationAllowedUntil",
        placeholder: "Enter a date",
      },
    ],
  },
};
